import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=55ebd412&scoped=true&"
import script from "./Performance.vue?vue&type=script&lang=js&"
export * from "./Performance.vue?vue&type=script&lang=js&"
import style0 from "./Performance.vue?vue&type=style&index=0&id=55ebd412&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ebd412",
  null
  
)

export default component.exports